import { Pipe, PipeTransform } from '@angular/core';
import { formatBytes, MaxFileSizeStrFormat } from '../index';

@Pipe({ name: 'size' })
export class SizeConverterPipe implements PipeTransform {
  transform(bytes: number, params: { decimals?: number; placeholder?: string } = {}): string {
    const { decimals = 2, placeholder = 'Unlimited' } = params;

    if (bytes == null || bytes.toString() === MaxFileSizeStrFormat) return placeholder;

    if (bytes === 0) return '0';

    return formatBytes(bytes, decimals);
  }
}
